import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
  MetricHighlight,
} from '../../../BuildingCharacteristics.styles'
import type { RenovationHistoryCardProps } from '../ConstructionTimelineTab.types'

export const RenovationHistoryCard: React.FC<RenovationHistoryCardProps> = ({
  renovationYear,
  yearsSinceRenovation,
  renovationPeriod,
  renovationStatus,
  t,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="refresh-cw" size="small" />
          {t('timeline.cards.renovationHistory.title')}
        </CardTitle>
      </CardHeader>
      <MetricGrid>
        <MetricRow>
          <MetricLabel>
            {t('timeline.labels.lastRenovation')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('overview.cards.status.tooltips.renovation.title')}
                shortDescription={t(
                  'overview.cards.status.tooltips.renovation.description'
                )}
                calculation={t(
                  'overview.cards.status.tooltips.renovation.calculation'
                )}
                importance={t(
                  'timeline.cards.renovationHistory.tooltips.lastRenovation.importance'
                )}
                source={t(
                  'timeline.cards.renovationHistory.tooltips.lastRenovation.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {renovationYear > 0
              ? renovationYear
              : t('timeline.labels.noRecord')}
          </MetricValue>
        </MetricRow>
        {yearsSinceRenovation > 0 && (
          <MetricRow>
            <MetricLabel>
              {t('timeline.labels.yearsSinceRenovation')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t(
                    'timeline.cards.renovationHistory.tooltips.yearsSince.title'
                  )}
                  shortDescription={t(
                    'timeline.cards.renovationHistory.tooltips.yearsSince.description'
                  )}
                  calculation={t(
                    'timeline.cards.renovationHistory.tooltips.yearsSince.calculation'
                  )}
                  importance={t(
                    'timeline.cards.renovationHistory.tooltips.yearsSince.importance'
                  )}
                  source={t(
                    'timeline.cards.renovationHistory.tooltips.yearsSince.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricValue>
              {yearsSinceRenovation} {t('common.years')}
            </MetricValue>
          </MetricRow>
        )}
        <MetricRow>
          <MetricLabel>
            {t('timeline.labels.renovationStatus')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t(
                  'timeline.cards.renovationHistory.tooltips.status.title'
                )}
                shortDescription={t(
                  'timeline.cards.renovationHistory.tooltips.status.description'
                )}
                categories={[
                  {
                    label: t(
                      'timeline.renovationCategories.recentlyRenovated.label'
                    ),
                    range: t(
                      'timeline.renovationCategories.recentlyRenovated.range'
                    ),
                    description: t(
                      'timeline.renovationCategories.recentlyRenovated.description'
                    ),
                  },
                  {
                    label: t('timeline.renovationCategories.good.label'),
                    range: t('timeline.renovationCategories.good.range'),
                    description: t(
                      'timeline.renovationCategories.good.description'
                    ),
                  },
                  {
                    label: t('timeline.renovationCategories.dueSoon.label'),
                    range: t('timeline.renovationCategories.dueSoon.range'),
                    description: t(
                      'timeline.renovationCategories.dueSoon.description'
                    ),
                  },
                  {
                    label: t('timeline.renovationCategories.overdue.label'),
                    range: t('timeline.renovationCategories.overdue.range'),
                    description: t(
                      'timeline.renovationCategories.overdue.description'
                    ),
                  },
                ]}
                importance={t(
                  'timeline.cards.renovationHistory.tooltips.status.importance'
                )}
                source={t(
                  'timeline.cards.renovationHistory.tooltips.renovationStatus.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricHighlight $type={renovationStatus.type}>
            {renovationStatus.label}
          </MetricHighlight>
        </MetricRow>
        {renovationPeriod && (
          <MetricRow>
            <MetricLabel>
              {t('timeline.labels.renovationPeriod')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t(
                    'timeline.cards.renovationHistory.tooltips.period.title'
                  )}
                  shortDescription={t(
                    'timeline.cards.renovationHistory.tooltips.period.description'
                  )}
                  calculation={t(
                    'timeline.cards.renovationHistory.tooltips.period.calculation'
                  )}
                  importance={t(
                    'timeline.cards.renovationHistory.tooltips.period.importance'
                  )}
                  source={t(
                    'timeline.cards.renovationHistory.tooltips.renovationPeriod.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricValue>{renovationPeriod}</MetricValue>
          </MetricRow>
        )}
      </MetricGrid>
    </Card>
  )
}
